/* eslint-disable no-useless-escape */
/* eslint-disable no-nested-ternary */
import {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { Row, Col, notification } from 'antd';
import styled from 'styled-components';
import { flushSync } from 'react-dom';
import {
  useLocation,
  useNavigate, useParams, useSearchParams,
} from 'react-router-dom';
import {
  useDispatch, useSelector,
} from 'react-redux';
import { actions as flurryActions } from 'Slice/HelperSlice';
import {
  selectCompanyProfile, selectDownloadedProfilePDF,
  selectDownloadedProfilePPT,
  selectProfileDownloadPdfLoading,
  selectCompanyStaff,
  selectNewsFiltersArray,
  selectCompanyNews,
  selectCompanyNewsFiltersApplied,
  selectProfileLoading,
  selectNewsLoading,
  selectCompanyNewsFiltersSelected,
  selectCompanyStaffLoading,
  selectCompanyVideo,
  selectNewsFilterApplied,
  selectSWOTLoading,
  selectSWOTData,
  selectSwotRefreshedCompany,
  selectCompanyBenefits,
  selectCurrentSections,
  selectCompanyStockCharts,
  selectLatestEarningScroll,
  selectAetnaSubsidiaryCompaniesLoading,
  selectCompanyStrategicHighlights,
  selectBlip,
  selectProductAndServices,
  selectProductAndServicesLoading,
} from 'Selector/CompaniesSelector';
import { actions as competitorsActions } from 'Slice/TopCompanyEntitySlice';
import {
  allValueInKeyOfArrayExists,
  getLocalStorageObject, isSalesforce,
  anyValueInKeyOfArrayExists, isAPrivateCompany, smoothBehavior,
  IsTablet, certificationSmoothBehavior, isElement, valueToObject, getCurrentTime,
  getLangCookie,
  getLocalStorageValue,
  getAppName,
} from 'Utils/UtilityFunctions';
import { usePrevious } from 'Utils/hooks/usePrevious';
import GlobalSearch from 'Components/globalSearch/components/GlobalSearch';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import {
  Company as CompanyType, CompanyDownloadProfile, CompanyStockChart,
} from 'Types/CompaniesTypes';
import { Filter } from 'Types/FilterTypes';
import ProfilePopups from 'Components/common/modal/ProfilePopups';
import AddCompanyLimitPopup from 'Components/common/modal/AddCompanyLimitPopup';
import {
  selectCompanyCompetitors, selectCompanyCompetitorsExecutives,
  selectCompanyExecutives, selectEntitiesLoading,
} from 'Selector/TopEntitiesSelector';
import { Executive } from 'Types/PersonTypes';
import { Article } from 'Types/ArticleTypes';
import classNames from 'classnames';
import CompanyVideoTab from 'Components/company/components/CompanyVideoTab';
import DrawerPeopleGroup from 'Components/people/components/DrawerPeopleGroup';
import { actions as groupActions } from 'Slice/GroupsSlice';
import { selectData } from 'Selector/BranchSelector';
import ViewTabs from 'Components/common/tabs/ViewTabs';
import SubNavBarPrimary from 'Components/layout/headers/SubNavBarPrimary';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import {
  selectActivetype,
  selectData as certificationData, selectIsScroll, selectPulseCompanyClicked, selectScrollToId,
  selectScrollToPage, selectSearchCompanyClicked, selectToasterFlag,
  selectAiCertificationData,
} from 'Selector/CertificationSelector';
import { ViewInterface } from 'Types/GlobalTypes';
import { isShowGilroyGlobal, selectViewTab } from 'Selector/UISelector';
import {
  maxMobile, maxTablet, maxWidth, maxWidth1170, retina, scrollbarTransparent,
} from 'Utils/utilsStyle';
import {
  COMPANY_OVERVIEW_ROUTE, COMPANY_ROUTE, COMPANY_TOASTER, GROUP_TOASTER,
} from 'Utils/Constants';
import SwotTab from 'Components/company/components/SwotTab';
import { selectScreenName, selectShowChatbot, selectShowGlobalGilroy, selectSAPHierarchyFlag, selectUserCompanyId } from 'Selector/GlobalSearchContentSelector';
import { TagItem } from 'Types/ChatBotV2Types';
import Benefits from 'Components/company/components/Benefits';
import FeedTabs from 'Components/common/tabs/Tabs';
import { Waypoint } from 'react-waypoint';
import { useGilroy } from 'Utils/hooks/useGilroy';
import { Gilroy } from 'gilroy-global';
import { SearchResultsRequest } from 'Types/GlobalSearchResultsTypes';
import {
  companiesData, selectLoading, selectSearchLoaded,
} from 'Selector/GlobalSearchResultsSelector';
import SearchResultPopup from 'Components/common/modal/SearchResultPopup';
import CompanyNewsTab from '../../Components/company/components/CompanyNewsTab';
import Financials from '../../Components/company/components/Financials';
import CompanyDetailsTab from '../../Components/company/components/CompanyDetailsTab';
import CompanyStaff from '../../Components/company/components/CompanyStaff';
import Competitors from '../../Components/company/components/Competitors';
import FilterPopOver from '../../Components/common/components/FilterPopOver';
import NavBarPrimary, { chatActions, chatStates } from '../../Components/layout/headers/NavBarPrimary';
import DrawerAlerts from '../../Components/alerts/components/DrawerAlerts';
import CompanyInfo from '../../Components/company/components/CompanyInfo';
import CompanyDetails from '../../Components/company/components/CompanyDetails';
import CompanyStyle from '../../Style/CompanyStyle';
import FeedStyle from '../../Style/FeedStyle';
import BackIcon from '../../Components/common/assets/svgIcons/BackIcon';
import CompanyCardSkeleton from '../../Components/common/skeleton/CompanyCardSkeleton';
import { actions as UiAction } from '../../Slice/UISlice';
import { actions as companiesActions } from '../../Slice/CompaniesSlice';
import { actions as searchActions } from '../../Slice/GlobalSearchResultsSlice';
import ProductAndServices from '../../Components/company/components/ProductAndServices';

const Wrapper = styled.div`
  .tabsNav {
    margin-top: 25px;
  }
  .tabSection {
    padding-top: 25px;
  }
  header{
    .tabsNav {
      margin-top: 0px;
      .heading-inner-page{
        margin-bottom:0;
      }
    }
  }
  .header-main-wrapper  {
    z-index: 3;
  }
  .sub-header-main-wrapper {
    z-index: 2;
    .heading-inner-page {
      max-width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      padding-top: 22px;
      margin-top: -22px;
      ${scrollbarTransparent};
      .tips-placeholder {
        margin-left: 0px !important;
      }
    }
  }
  .container-company-card {
    @media all and (max-width: ${maxMobile}) {
     position: relative;
     padding-top: 90px;
    };
  }
  .second-col-area {
    @media all and (max-width: ${maxMobile}) {
     position: initial;
    };
    .header-element {
      @media all and (max-width: ${maxMobile}) {
        width: 100%;
        padding-left: 20px;
        position: absolute;
        right: 10px;
        top: 20px;
      }
    }
  }
  .boxDoor {
    @media all and (max-width: ${maxWidth1170}) {
      top: 201px;
    }
  }
  .container {
     &.bottomAccordion {
      .chatbot-v2 {
        margin-bottom: 200px;
      }
    }
    .chatbot-v2 {
      @media all and (max-width: ${maxWidth}), ${retina} {
        margin-bottom: 0px;
      }
    }
    &.chatbot-container {
      padding-bottom: 5px;
      @media all and (max-width: ${maxTablet}) {
        padding-bottom: 20px;
      }
      .boxDoor {
       @media all and (max-width: ${maxTablet}) {
         display: none;
       }
     }
    }
  }
`;

type TabsInterface = {
  [key: string]: JSX.Element
};

const Company = function Company() {
  const { gilroyStates, gilroyActions } = useGilroy();
  const { saveUrl: savedUrlV2 } = chatStates;
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [dragging, setDragging] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tabsFlag, setTabsFlag] = useState(false);
  const [navList, setNavList] = useState<string[]>([]);
  const [navLoad, setNavLoad] = useState<boolean>(false);
  const [filters, setFilters] = useState<Filter[]>([]);
  const [previousNewsFiltersApplied, setPreviousNewsFiltersApplied] = useState<Filter[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(true);
  const [isCompanySearchVisible, setIsCompanySearchVisible] = useState(false);
  const newsFiltersFromRedux = useSelector(selectNewsFiltersArray);
  const selectedNewsFilters = useSelector(selectCompanyNewsFiltersSelected);
  const previousNewsFiltersLocal = usePrevious(filters);
  const [isFilterActive, setIsFilterActive] = useState<boolean>(false);
  const [isFilterChanged, setIsFilterChanged] = useState<boolean>(false);
  const [selectedStrategicHighlight, setSelectedStrategicHighlight] = useState<string | undefined>(undefined);
  // News Filters States ends here
  const companyProfile = useSelector(selectCompanyProfile);
  const companyProfileLoading = useSelector(selectProfileLoading);
  const companyNewsLoading = useSelector(selectNewsLoading);
  const companyStaffLoading = useSelector(selectCompanyStaffLoading);
  const topEntitiesLoading = useSelector(selectEntitiesLoading);
  const downloadedPDF: CompanyDownloadProfile | null = useSelector(selectDownloadedProfilePDF);
  const downloadedPPT: CompanyDownloadProfile | null = useSelector(selectDownloadedProfilePPT);
  const companyProfileDownloadLoading = useSelector(selectProfileDownloadPdfLoading);
  const companyStaff = useSelector(selectCompanyStaff);
  const companyBenefits = useSelector(selectCompanyBenefits);
  const downloadFileExtension = downloadedPDF?.file_extension || downloadedPPT?.file_extension;
  const userAccountDetails = companyProfile?.userAccountDetails;
  const tabView: ViewInterface = useSelector(selectViewTab);
  const isListView = tabView.view === 'listView';
  const getPath = getLocalStorageObject('ViewTab') as ViewInterface;
  const executives: Executive[] | undefined = useSelector(selectCompanyCompetitorsExecutives);
  const companies: CompanyType[] | undefined = useSelector(selectCompanyCompetitors);
  const companyNewsArticles: Article[] | null = useSelector(selectCompanyNews);
  const newsFilterApplied: boolean = useSelector(selectNewsFilterApplied);
  const filtersApplied: string = useSelector(selectCompanyNewsFiltersApplied);
  const scrollToId: string = useSelector(selectScrollToId);
  const isScroll: boolean = useSelector(selectIsScroll);
  const scrollToPage: string = useSelector(selectScrollToPage);
  const companyVideoArticles: Article[] | null = useSelector(selectCompanyVideo);
  const strategicHighlights = useSelector(selectCompanyStrategicHighlights) || [];
  const productAndServices = useSelector(selectProductAndServices);
  const productAndServicesLoading = useSelector(selectProductAndServicesLoading);
  const blip = useSelector(selectBlip);
  const branchData = useSelector(selectData);
  const { data_parsed: dataParsed } = branchData || {};
  const isTab = IsTablet();
  const { section } = useParams();
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const filtersId = searchParams.get('filterId');
  const redirectTo = searchParams.get('redirectTo');
  const showAccountPlan = searchParams.get('accountPlan');
  const searchTerm = searchParams.get('search');
  const [paramFilters, setParamFilters] = useState<string>('');
  const [scroll, setScroll] = useState<boolean>(false);
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const [redirect, setRedirect] = useState('');
  const [disableFilter, setDisableFilter] = useState(true);
  const [backNavigation, setBackNavigation] = useState(-1);

  useEffect(() => {
    if (filtersId) {
      setParamFilters(filtersId);
      setIsFilterActive(true);
      setIsFilter(true);
    }
  }, [searchParams]);

  const showSAPHierarchy = useSelector(selectSAPHierarchyFlag);
  const userCompanyId = useSelector(selectUserCompanyId);
  const aetnaSubsidiaryCompaniesLoading = useSelector(selectAetnaSubsidiaryCompaniesLoading);
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;
  const currentType = useSelector(selectActivetype);
  const exec: Executive[] | undefined = useSelector(selectCompanyExecutives);
  const isSearchCompany: boolean = useSelector(selectSearchCompanyClicked);
  const isPulseCompany: boolean = useSelector(selectPulseCompanyClicked);
  const data = useSelector(certificationData);
  const toasterFlag = useSelector(selectToasterFlag);
  const currentUrl = window.location.href;
  const [isToaster, setIsToaster] = useState(toasterFlag);
  const swotLoading = useSelector(selectSWOTLoading);
  const swotData = useSelector(selectSWOTData);
  const swotRefreshedCompany = useSelector(selectSwotRefreshedCompany);
  const startTime = getCurrentTime();
  const isShowGilroyGlobalFlag = useSelector(isShowGilroyGlobal);
  const chatbotAllowed = useSelector(selectShowChatbot);
  const allowGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const aiCertificationData = useSelector(selectAiCertificationData);
  const currentSections = useSelector(selectCurrentSections);
  const stocksData: CompanyStockChart | null = useSelector(selectCompanyStockCharts);
  const chartsData = stocksData?.chartsData;
  const latestEarningScroll = useSelector(selectLatestEarningScroll);
  const screenName = useSelector(selectScreenName);
  const isSearchLoaded = useSelector(selectSearchLoaded);
  const companyCollection = useSelector(companiesData);
  const searchLoading = useSelector(selectLoading);
  const companiesToDisplay = companyCollection?.companies;
  const location = useLocation();
  const prevUrl = location.state?.from;
  const gilroyRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!searchLoading && isSearchLoaded && isSalesforce() && searchTerm?.length) {
      if (companiesToDisplay?.length === 0) {
        setIsCompanySearchVisible(true);
      }
    }
  }, [isSearchLoaded]);

  useEffect(() => {
    if (searchTerm && isSalesforce() && !companiesToDisplay?.length) {
      // dispatch(personProfileActions.setSalesForcePersonSearchLoading(true));
      const obj: SearchResultsRequest = {
        query: `company:${searchTerm}`,
        screenName,
        page: 1,
        defaultLanguage: getLangCookie(),
      };
      dispatch(searchActions.globalSearchResults(obj));
    }
  }, [searchTerm]);

  useEffect(() => {
    const shouldFetchAetnaSubsidiaries = showSAPHierarchy
      && !aetnaSubsidiaryCompaniesLoading

    if (shouldFetchAetnaSubsidiaries) {
      dispatch(companiesActions.getAetnaSubsidiaryCompanies({
        companyId: userCompanyId,
        username: getLocalStorageValue('email') || '',
        appName: getAppName(),
      }));
    }
  }, [
    showSAPHierarchy,
    userCompanyId,
    dispatch,
  ]);

  useEffect(() => {
    if (isSalesforce() && searchTerm?.length) {
      if (companiesToDisplay?.length === 1) {
        const [company] = companiesToDisplay;
        navigate(`${COMPANY_OVERVIEW_ROUTE}${company.companyId}`, { replace: true });
        setBackNavigation(-2);
      } else if (companiesToDisplay && companiesToDisplay?.length > 1) {
        setIsCompanySearchVisible(true);
      }
    }
  }, [companiesToDisplay, searchTerm]);

  const applyParamFilterhandler = () => {
    dispatch(companiesActions.setCompanyNewsPageNumber(1));
    dispatch(companiesActions.setNewsFilterApplied());
    dispatch(companiesActions.getCompanyNews({
      companyId: companyIdParsed,
      newsFilters: paramFilters,
      page: 1,
    }));
    dispatch(companiesActions.setCompanyNewsFiltersSelected(paramFilters));
  };

  useEffect(() => {
    if (swotRefreshedCompany) {
      if (swotRefreshedCompany === companyIdParsed) {
        dispatch(companiesActions.getSWOTAnalysis({ companyId: swotRefreshedCompany }));
      }
      dispatch(companiesActions.setSwotRefreshedCompany(0));
    }
  }, [swotRefreshedCompany]);

  useEffect(() => {
    if (paramFilters.length) {
      applyParamFilterhandler();
    }
  }, [paramFilters]);

  useEffect(() => {
    if (latestEarningScroll && !companyNewsLoading) {
      smoothBehavior('trigger-details');
      dispatch(companiesActions.setLatestEarningScroll(false));
    }
  }, [latestEarningScroll, companyNewsLoading]);

  useEffect(() => {
    if (scroll && !companyNewsLoading && newsFiltersFromRedux.length) {
      smoothBehavior();
      setScroll(false);
      const tempFilters = filters.map((filter) => ({ ...filter, isSelected: paramFilters.split(',').includes(filter.filterId) }));
      setFilters(tempFilters);
      setIsFilterChanged(true);
    }
  }, [scroll, companyNewsLoading, newsFiltersFromRedux]);

  const handleGilroyClose = () => {
    setSelectedStrategicHighlight(undefined);
  };

  const handleHighlightClick = (prompt: string) => {
    flushSync(() => setSelectedStrategicHighlight(undefined));
    setSelectedStrategicHighlight(prompt);
    dispatch(flurryActions.callFlurryEvent(
      valueToObject(`company_highlights_clicked`, startTime, {
        companyId: companyIdParsed,
        company: companyProfile?.companyName,
        prompt,
      }),
    ));
  };

  const isDrag = (a: boolean) => {
    if (a) dispatch(groupActions.setDropComplete(false));
    setDragging(a);
  };

  const TagCompany: TagItem = {
    type: 'company',
    id: companyProfile?.companyId ?? 0,
    name: companyProfile?.companyName ?? '',
    image: companyProfile?.companyLogo ?? '',
    color: companyProfile?.companyPersonality?.length ? companyProfile?.companyPersonality[0]?.color || '' : '',
    companyPersonality: companyProfile?.companyPersonality,
    companyPulse: companyProfile?.companyPulse,
    companyWebsite: companyProfile?.companyWebsite,
  };

  const tabs: TabsInterface = {
    news: <CompanyNewsTab listview={isListView} strategicHighlights={strategicHighlights} tagCompany={TagCompany} onGilroyClose={handleGilroyClose} handleHighlightClick={handleHighlightClick} />,
    strategichighlights: <CompanyNewsTab listview={isListView} tagCompany={TagCompany} strategicHighlights={strategicHighlights} onGilroyClose={handleGilroyClose} handleHighlightClick={handleHighlightClick} />,
    swot: <SwotTab />,
    videos: <CompanyVideoTab listview={isListView} />,
    details: <CompanyDetailsTab />,
    staff: <CompanyStaff
      isDrag={isDrag}
    />,
    competitors: <Competitors
      isDrag={isDrag}
    />,
    productandservices: <ProductAndServices />,
    financials: <Financials redirect={redirect} />,
    benefits: <Benefits />,
  };

  const onChangeFilters = (flag: boolean, id: string) => {
    const tempFilters = filters.map((filter) => {
      if (filter.filterId === id) {
        return { ...filter, isSelected: flag };
      } return { ...filter };
    });
    setFilters(tempFilters);
    setSelectAll(allValueInKeyOfArrayExists(tempFilters, 'isSelected', true));
  };

  const selectOrUnselectAll = (flag: boolean) => {
    const tempFilters = filters.map((filter) => ({ ...filter, isSelected: flag }));
    setFilters(tempFilters);
  };

  const onClickHandler = () => {
    selectOrUnselectAll(!selectAll);
    setSelectAll(!selectAll);
  };

  const applyFilterHandler = () => {
    dispatch(companiesActions.setCompanyNewsPageNumber(1));
    dispatch(companiesActions.setNewsFilterApplied());
    const selectedFilter = filters.filter((item) => item.isSelected).map((item) => item.filterId).join(',');
    dispatch(companiesActions.getCompanyNews({
      companyId: companyIdParsed,
      ...selectedFilter.length ? {
        newsFilters: selectedFilter,
      } : {},
      page: 1,
    }));
    dispatch(companiesActions.setCompanyNewsFiltersSelected(selectedFilter));
    setPreviousNewsFiltersApplied(filters);
    setIsFilterChanged(true);
  };

  useEffect(() => {
    if (isFilterChanged) {
      if (anyValueInKeyOfArrayExists(filters, 'isSelected', false)) {
        setIsFilterActive(true);
      } else {
        setIsFilterActive(false);
      }
      setIsFilterChanged(false);
    }
  }, [isFilterChanged, filters]);

  useEffect(() => {
    window.scroll(0, 0);
    notification.destroy();
  }, []);

  useEffect(() => () => {
    dispatch(companiesActions.setShowSAPHistory(false));
  }, []);

  const companyPageLoadFlurry = () => {
    const obj = {
      companyId: companyIdParsed,
      ...(dataParsed?.source && {
        source: dataParsed?.source,
      }),
    };
    dispatch(flurryActions.callFlurryEvent(
      valueToObject(
        'company_page_load',
        startTime,
        {
          ...obj,
          ...(obj.source && {
            article_entity_name: companyProfile?.companyName,
          }),
          company_name: companyProfile?.companyName,
        },
      ),
    ));
  };

  const initialComponentActions = () => {
    setNavLoad(false);
    window.scrollTo(0, 0);

    if (companyIdParsed) {
      if (currentUrl !== savedUrlV2) {
        if (!companyProfile || !latestEarningScroll) {
          dispatch(companiesActions.getCompanyProfile({
            companyId: companyIdParsed,
            ...(dataParsed?.source && {
              source: dataParsed?.source,
            }),
          }));
        }
        dispatch(companiesActions.getCompanyBenefits({ companyId: companyIdParsed }));
        if (!chartsData || !latestEarningScroll) {
          dispatch(companiesActions.getStockChart({ companyId: companyIdParsed }));
        }
        if (!exec?.length || !latestEarningScroll) {
          dispatch(competitorsActions.getTopCompanyEntities({ companyId: companyIdParsed }));
        }
        dispatch(companiesActions.getCompanyStaff({ companyId: companyIdParsed }));
        dispatch(companiesActions.getProductAndServices({ companyId: companyIdParsed }));
        dispatch(companiesActions.resetCompanyNews({}));
        dispatch(companiesActions.resetAccountPlan());
        if (!showAccountPlan) {
          dispatch(companiesActions.setShowSAPHistory(false));
        }
        if (!filtersId?.length && !paramFilters.length && !isFilter) {
          dispatch(companiesActions.getCompanyNews(
            {
              companyId: companyIdParsed,
              page: 1,
              ...filtersApplied?.length ? {
                newsFilters: filtersApplied,
              } : {},
            },
          ));
        }

        dispatch(companiesActions.getCompanyVideos({
          companyId: companyIdParsed,
          page: 1,
          videos: true,
        }));
        dispatch(companiesActions.getCompanyPulse({ companyId: companyIdParsed }));
        dispatch(companiesActions.getCompanyIntentData({ companyId: companyIdParsed }));
        dispatch(companiesActions.getCompanyWorkbenchStats(companyIdParsed));
        setTabsFlag(true);
        if (!filtersApplied?.length) { dispatch(companiesActions.resetNewsFilterApplied()); }

        dispatch(companiesActions.getSWOTAnalysis({ companyId: companyIdParsed }));
      }
    } else if (!(searchTerm && isSalesforce())) {
      navigate(-1);
    }
  };
  useEffect(() => {
    if (isSearchCompany) {
      dispatch(certificationActions.certificationAction({
        type: 'company_select',
        source: 'search',
        data,
      }));
      dispatch(certificationActions.setSearchCompanyClicked(false));
    }
  }, [isSearchCompany]);

  useEffect(() => {
    if (isPulseCompany) {
      dispatch(certificationActions.certificationAction({
        type: 'pulse_company',
        source: 'pulse',
        data,
      }));
      dispatch(certificationActions.setPulseCompanyClicked(false));
    }
  }, [isPulseCompany]);

  useEffect(() => {
    if (currentUrl !== savedUrlV2) {
      dispatch(UiAction.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      chatActions.setHistoryPanelOpened(false);
    } else {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
    }
    if (companyProfile?.companyId !== companyIdParsed) initialComponentActions();
    else {
      companyPageLoadFlurry();
      setTabsFlag(true);
    }
  }, [companyIdParsed]);

  useEffect(() => {
    if (filtersApplied.length && !isFilter) initialComponentActions();
  }, [filtersApplied]);

  useEffect(() => {
    if (selectedNewsFilters.length) {
      const filterId = selectedNewsFilters.split(',');
      const filterTemp = newsFiltersFromRedux.map((filter) => {
        if (filterId.includes(filter.filterId)) {
          return { ...filter, isSelected: true };
        }
        return { ...filter, isSelected: false };
      });
      setFilters(filterTemp);
      setPreviousNewsFiltersApplied(filterTemp);
    } else {
      setFilters(newsFiltersFromRedux);
      setPreviousNewsFiltersApplied(newsFiltersFromRedux);
    }

    setSelectAll(allValueInKeyOfArrayExists(newsFiltersFromRedux, 'isSelected', true));
  }, [newsFiltersFromRedux]);

  useEffect(() => {
    if (filtersApplied?.length && filters?.length && !previousNewsFiltersLocal?.length) {
      const filtersAppliedIds = filtersApplied.split(',');
      const tempFilters = filters.map((filter) => (
        {
          ...filter,
          isSelected: filtersAppliedIds.includes(filter.filterId),
        }));
      setFilters(tempFilters);
      setPreviousNewsFiltersApplied(tempFilters);
      const selectedFilter = tempFilters.filter((item) => item.isSelected).map((item) => item.filterId).join(',');
      dispatch(companiesActions.setCompanyNewsFiltersSelected(selectedFilter));
      dispatch(companiesActions.setCompanyNewsFiltersApplied(''));
    }
  }, [filters, filtersApplied]);

  useEffect(() => {
    if (companyIdParsed) {
      dispatch(companiesActions.setStrategicHighlights([]));
      dispatch(companiesActions.getStrategicHighlights({ id: companyIdParsed, type: 'company', key: 'company_strategic_highlights' }));
    }
  }, [companyIdParsed]);

  const haveDataForCompanyDetails = () => {
    if (!companyProfile) return false;
    if (companyProfile
      && !companyProfile?.companyCeo?.personName
      && !companyProfile?.companyFounded?.length
      && !companyProfile?.description?.length
    ) return false;
    return true;
  };

  const haveDataForCompanyStaff = () => {
    if (!companyStaff) return false;
    if (companyStaff && !companyStaff?.response?.length) return false;
    const filteredStaffGroups = companyStaff.response.filter(
      (groupType) => groupType.data.length !== 0,
    );
    if (!filteredStaffGroups.length) return false;
    return true;
  };

  const haveDataForCompanyCompetitors = () => {
    if (!executives && !companies) return false;
    if (!executives?.length && !companies?.length) return false;
    return true;
  };

  const getNavArray = () => {
    const navArray = [];
    if (tabsFlag) {
      navArray.push('Overview');
    } if (tabsFlag && strategicHighlights.length) {
      navArray.push('Strategic Highlights');
    } if (tabsFlag && swotData?.swotAnalysis.length) {
      navArray.push('SWOT');
    } if ((tabsFlag && companyNewsArticles?.length) || newsFilterApplied) {
      navArray.push('Sales Triggers');
    } if (tabsFlag && haveDataForCompanyStaff()) {
      navArray.push('Staff');
    }
    if (tabsFlag && companyProfile && !isAPrivateCompany(companyProfile)) {
      navArray.push('Financials');
    }
    if (tabsFlag && (productAndServices?.products?.length || productAndServices?.services?.length)) {
      navArray.push('Product and Services');
    }
    if (tabsFlag && companyVideoArticles?.length) {
      navArray.push('Videos');
    }
    if (tabsFlag && haveDataForCompanyDetails()) {
      navArray.push('Details');
    }
    if (tabsFlag && haveDataForCompanyCompetitors()) {
      navArray.push('Competitors');
    }
    if (companyBenefits && companyBenefits.length) {
      navArray.push('Benefits');
    }
    return navArray;
  };

  const checkForApplyFilter = () => {
    for (let i = 0; i < filters.length; i += 1) {
      if (filters[i].isSelected !== previousNewsFiltersApplied[i]?.isSelected) return false;
    }
    return true;
  };

  const showRestrictedLoading = userAccountDetails
    && (userAccountDetails.showPlanPopup === 3
      || userAccountDetails?.showPlanPopup === 8)
    && !userAccountDetails.isDownloadPopup;

  useEffect(() => {
    if (companyProfile?.companyId === companyIdParsed
      && (!companyNewsLoading && !companyProfileLoading && !topEntitiesLoading
        && !companyStaffLoading && !swotLoading && !productAndServicesLoading)) {
      setNavList(getNavArray());
      setNavLoad(true);
    }
  }, [companyNewsLoading, companyProfileLoading, swotLoading,
    companyStaffLoading, topEntitiesLoading, productAndServicesLoading, companyIdParsed]);

  useEffect(() => {
    if (navList.length) {
      if (isFilter) {
        navigate(`${COMPANY_ROUTE}${section || navList[0].toLocaleLowerCase()}?companyId=${companyIdParsed}`, { replace: true, state: { from: prevUrl } });
        setScroll(true);
        setIsFilter(false);
      } else {
        navigate(`${COMPANY_ROUTE}${redirectTo || section || navList[0].toLocaleLowerCase()}?companyId=${companyIdParsed}`, { replace: true, state: { from: prevUrl } });
      }
    }
  }, [navList.length, isFilter]);

  useEffect(() => {
    if (companyProfile?.companyId !== companyIdParsed) setNavList([]);
    dispatch(companiesActions.setPodcasts([]));
  }, [companyIdParsed]);

  const toggle = (flag: boolean) => {
    setOpenCreateModal(flag);
  };

  useEffect(() => {
    dispatch(UiAction.isTabView({
      view: getPath.view,
    }));
  }, [getPath.view]);

  useEffect(() => {
    setShowNew(false);
    setOpenCreateModal(dragging);
  }, [dragging]);

  useEffect(() => {
    if (redirectTo) setRedirect(redirectTo);
  }, [redirectTo]);

  useEffect(() => {
    if (isScroll && scrollToPage.includes(COMPANY_ROUTE)) {
      certificationSmoothBehavior(scrollToId);
      dispatch(certificationActions.setIsScroll(false));
    }
  }, [scrollToId, isScroll]);

  useEffect(() => {
    if (isToaster && data.companyId === companyIdParsed && navLoad && (
      (getNavArray().length !== 8 && currentType === 'company_sales')
      || (!exec?.length && currentType === 'company_profile')
      || (!companyProfile?.companyPdfFlag && currentType === 'company_download_header'))) {
      dispatch(flurryActions.setNotification({
        message: COMPANY_TOASTER,
        proTip: true,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
        certification: true,
        type: 'company',
      }));
      if (toasterFlag) {
        dispatch(certificationActions.setToasterFlag(false));
      }
    } else if (isToaster && !data.groupId && navLoad && (currentType === 'buyer_navigate' || currentType === 'buyer_group' || currentType === 'open_buyer_group' || currentType === 'buyer_group_execute_prompt_2' || currentType === 'buyer_group_execute_prompt_3') && companyIdParsed === 238) {
      dispatch(flurryActions.setNotification({
        message: GROUP_TOASTER,
        proTip: true,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
        certification: true,
        type: 'group',
      }));
      if (toasterFlag) {
        dispatch(certificationActions.setToasterFlag(false));
      }
    } else {
      dispatch(flurryActions.setNotification({
        message: '',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
    }
  }, [data.companyId, currentType, companyIdParsed, navLoad, isToaster]);

  useEffect(() => {
    if (data.companyId !== companyIdParsed) {
      notification.destroy();
    }
  }, [companyIdParsed]);

  useEffect(
    () => () => {
      dispatch(flurryActions.setNotification({
        message: '',
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
      notification.destroy();
    },
    [],
  );

  useEffect(() => {
    setIsToaster(toasterFlag);
  }, [toasterFlag]);

  useEffect(() => {
    const element: HTMLElement | null = document.getElementById('tabs-details');
    if (element && section === 'swot' && !companyProfileLoading && !companyNewsLoading) {
      isElement(element, -120);
    }
  }, [companyProfileLoading, companyNewsLoading]);

  useEffect(() => {
    if (companyProfile?.companyId) {
      dispatch(certificationActions.aiCertificationAction({
        type: 'open_company_profile',
        source: 'company_gilroy',
        data: aiCertificationData,
      }));
      dispatch(certificationActions.aiCertificationAction({
        type: 'company_profile_sap',
        source: 'sap',
        data: aiCertificationData,
      }));
    }
  }, [companyProfile]);

  useEffect(() => {
    if (currentSections.length === 1 && currentSections[0] === 'Sales Triggers') {
      setDisableFilter(false);
    } else {
      setDisableFilter(true);
    }
  }, [currentSections]);

  const tabToHighlight = () => {
    if (currentSections.length === 1) {
      if (currentSections[0] === 'S.W.O.T') {
        return 'SWOT';
      } else return currentSections[0];
    }
    else if (currentSections.length === 2 && currentSections.includes('Overview') && currentSections.includes('Sales Triggers')) {
      return 'Overview';
    }
    else if (currentSections.length === 2 && currentSections.includes('S.W.O.T') && currentSections.includes('Sales Triggers')) {
      return 'Sales Triggers';
    }
    else if (currentSections.length > 1 && currentSections.includes('S.W.O.T')) {
      return 'SWOT';
    }
    else if (currentSections.length > 1 && currentSections.includes('Strategic Highlights')) {
      return 'Strategic Highlights';
    }
  };

  // Add this useEffect to detect clicks outside Gilroy
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (gilroyRef.current && !gilroyRef.current.contains(event.target as Node)) {
        // Call the callback when clicking outside
        handleGilroyClose();
      }
    };

    // Only add listener when Gilroy is visible
    if (chatbotAllowed && allowGlobalGilroy && TagCompany?.id === companyIdParsed) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [chatbotAllowed, allowGlobalGilroy, TagCompany?.id, companyIdParsed]);

  return (
    <Wrapper>
      <CompanyStyle />
      <FeedStyle />
      <NavBarPrimary headerClassName="no-overflow-on-header">
        <div className="left-side-wrap">
          {!companyProfileLoading
            ? (
              <BackIcon onClick={() => {
                if (isShowGilroyGlobalFlag) {
                  dispatch(UiAction.isShowGilroyGlobalToggle(false));
                } else {
                  navigate(backNavigation);
                }
                dispatch(companiesActions.setStrategicHighlights([]));
              }}
              />
            ) : null}
          {
            companyProfile && companyProfile.companyId === companyIdParsed ? (
              <h1 className="heading text-truncate-two-line">{companyProfile?.companyName}</h1>
            ) : <SkeletonCustom height="28px" width="360px" margin="0px 0px 0px 10px" />
          }
        </div>
        <div className="right-side-wrap c-pointer">
          <GlobalSearch iconMode={isTab} />
          <DrawerAlerts />
          <AccountPopOver />
        </div>
      </NavBarPrimary>
      <SubNavBarPrimary>
        <div className="heading-inner-page tabs-placeholder wrap-slider hidden-scroll forOverFlow">
          <div className="head-wrap" />
          <div className="tips-placeholder">
            <FeedTabs
              baseComponentPath="company"
              tabsName={getNavArray()}
              loading={companyProfileLoading}
              elementTarget="tabs-details"
              headerAppendTab
              companyActiveTab={tabToHighlight()}
              strategicHighlightsIconProp={blip}
            />
          </div>
          <div className="right-side-sub-header">
            <div className={classNames('view-tabs', {
              notdisabledTabs: true,
            })}
            >
              <ViewTabs
                disabled={disableFilter}
                listView={isListView}
              />
            </div>
            <div className={classNames('filter-placeholder', {
              notDisabledFilter: (companyNewsArticles?.length
                || newsFilterApplied)
                && filters.length > 0 && !disableFilter,
            })}
            >
              <FilterPopOver
                filters={filters}
                loading={false}
                selectAll={selectAll}
                onChangeFilters={onChangeFilters}
                onClickHandler={onClickHandler}
                applyFilterHandler={applyFilterHandler}
                disableApplyBtn={checkForApplyFilter()}
                iconMode={isTab}
                isActive={isFilterActive && !disableFilter}
                salesTriggerPopup
                showContent={!disableFilter}
              />
            </div>
          </div>
        </div>
      </SubNavBarPrimary>
      {chatbotAllowed && allowGlobalGilroy && TagCompany?.id === companyIdParsed ? (
        <div ref={gilroyRef} className="container chatbot-container">
          <Gilroy
            gilroyStates={gilroyStates}
            gilroyActions={gilroyActions}
            tagItem={TagCompany}
            seedPrompt={selectedStrategicHighlight}
          />
        </div>
      ) : null}
      <div className="container">
        <DrawerPeopleGroup
          openNewCreate={openCreateModal}
          setOpenNew={toggle}
          showNew={showNew}
          toggleShowNew={(bool: boolean) => setShowNew(bool)}
          noButton
          drag={dragging}
        />
        {userAccountDetails && userAccountDetails?.showPlanPopup >= 0
          ? (
            <ProfilePopups
              isCompany
              companyId={companyIdParsed}
              title={userAccountDetails?.popUpHeading}
              description={userAccountDetails?.popUpText}
              type={userAccountDetails?.showPlanPopup}
              callToAction={userAccountDetails?.callToAction}
              contactUs={userAccountDetails?.contactUsEmail}
              isDownloadPopup={userAccountDetails?.isDownloadPopup}
              ispdf={downloadFileExtension === 'pdf' ? 1 : 0}
              loading={companyProfileDownloadLoading}
            />
          ) : null}
        <AddCompanyLimitPopup />
        <Waypoint onEnter={() => dispatch(companiesActions.pushCurrentSection('Overview'))} onLeave={() => dispatch(companiesActions.removeCurrentSection('Overview'))}>
          <div className={`container-company-card company-${section === 'overview' || section === 'news' || section === 'swot' ? 'overview' : ''}-section`} id="certification-company-tabs">
            {
              !showRestrictedLoading
                && companyProfile
                && companyProfile.companyId === companyIdParsed
                ? (
                  <Row>
                    <Col
                      xxl={{ span: 6 }}
                      xl={{ span: 8 }}
                      lg={{ span: 8 }}
                      md={{ span: 8 }}
                      sm={{ span: 24 }}
                      xs={{ span: 24 }}
                    >
                      {companyProfile && <CompanyInfo companyProfile={companyProfile} />}
                    </Col>
                    <Col
                      xxl={{ span: 18 }}
                      xl={{ span: 16 }}
                      lg={{ span: 16 }}
                      md={{ span: 16 }}
                      sm={{ span: 24 }}
                      xs={{ span: 24 }}
                      className="second-col-area"
                    >
                      {companyProfile && <CompanyDetails companyProfile={companyProfile} showSAPHierarchy={showSAPHierarchy} userCompanyId={userCompanyId} />}
                    </Col>
                  </Row>
                ) : isTab ? (
                  <SkeletonCustom
                    height="400px"
                    width="100%"
                    logo
                    margin="0px 0px 0px 0px"
                    marginSm="0px 0px 0px 0px"
                    className="skeleton"
                  />
                ) : <CompanyCardSkeleton />
            }
          </div>
        </Waypoint>
        {useMemo(
          () => (
            showRestrictedLoading ? null : <div className={`tabSection company-${section === 'overview' || section === 'news' || section === 'swot' ? '' : section || ''}-section`} id="tabs-details">{tabs[section && section !== 'overview' ? section : 'news']}</div>
          ),
          [section, isListView, redirect, strategicHighlights],
        )}
      </div>
      {isSalesforce() ? (
        <SearchResultPopup
          type="company"
          count={companyCollection?.count}
          searchQuery={searchTerm || ''}
          companies={companiesToDisplay || []}
          isVisible={isCompanySearchVisible}
          setIsVisible={setIsCompanySearchVisible}
        />
      ) : null}
    </Wrapper>
  );
};

export default Company;
